import axios from 'axios';
import { getParentOrigin } from './parentOrigin';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://api.simplymail.space',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default {
  saveMyHomePhotos(authToken, form) {
    return apiClient.post('/user/my-home/photos/sync', form, {
      headers: { Authorization: `Basic ${authToken}`, 'Content-Type': undefined }, timeout: 65000,
    });
  },
  saveMyHomeVehicles(authToken, vehicles) {
    return apiClient.put('/user/my-home/vehicles', { vehicles }, {
      headers: { Authorization: `Basic ${authToken}` }, timeout: 65000,
    });
  },
  getMyHomeDetails(authToken, signal) {
    return apiClient.get('/user/my-home/details', {
      headers: { Authorization: `Basic ${authToken}` }, signal, timeout: 50000,
    });
  },
  getMyHomePhoto(authToken, photoId, signal) {
    return apiClient.get(`/user/my-home/photos/${photoId}`, {
      headers: { Authorization: `Basic ${authToken}` }, signal, timeout: 50000, responseType: 'blob',
    });
  },
  getMyHomeAccess(authToken, signal) {
    return apiClient.get('/user/my-home', {
      headers: { Authorization: `Basic ${authToken}` },
      signal,
      timeout: 50000,
    });
  },

  // Авторизація
  authorize(authData) {
    return apiClient.post('/authorize', {
      ...authData,
      parent_origin: getParentOrigin(),
    });
  },

  // Отримання інформації про користувача
  getUserInfo(authToken) {
    return apiClient.get('/user/info', {
      params: { auth_token: authToken },
    });
  },

  // Отримання даних про інтернет-послуги користувача
  getUserInternet(authToken) {
    return apiClient.get('/user/internet', {
      params: { auth_token: authToken },
    });
  },

  // Отримання даних про ТВ-послуги користувача
  getUserTv(authToken) {
    return apiClient.get('/user/tv', {
      params: { auth_token: authToken },
    });
  },

  // Поповнення балансу
  fillBalance(authToken, balanceData) {
    return apiClient.post('/balance/fill', balanceData, {
      params: { auth_token: authToken },
    });
  },

  // Оплата інтернету
  payForInternet(authToken, paymentData) {
    return apiClient.post('/payment/internet', paymentData, {
      params: { auth_token: authToken },
    });
  },

  // Оплата ТВ
  payForTv(authToken, paymentData) {
    return apiClient.post('/payment/tv', paymentData, {
      params: { auth_token: authToken },
    });
  },

  payForTvBalance(authToken, paymentData) {
    return apiClient.post('/payment/tv_balance', paymentData, {
      params: { auth_token: authToken },
    });
  },

  payForInternetBalance(authToken, paymentData) {
    return apiClient.post('/payment/internet_balance', paymentData, {
      params: { auth_token: authToken },
    });
  },

  payForAdditionalServices(authToken, invoiceId ) {
    return apiClient.get('/pay_for_invoice', {
      params: { auth_token: authToken, invoice_id: invoiceId },
    });
  },

  getInternetTariffs(authToken) {
    return apiClient.get('/tariff/internet', {
      params: { auth_token: authToken },
    });
  },

  getTvTariffs(authToken) {
    return apiClient.get('/tariff/tv', {
      params: { auth_token: authToken },
    });
  },

  getAllNotifications(userId) {
    return apiClient.get('/get_notifications', {
      params: { user_id: userId },
    });
  },

  setPushToken(userId, pushToken) {
    return apiClient.get('/set_push_token', {
      params: { user_id: userId, push_token: pushToken },
    });
  },

  deletePushToken(userId, pushToken) {
    return apiClient.get('/delete_push_token', {
      params: { user_id: userId, push_token: pushToken },
    });
  },

  botAuth(login, password, locale) {
    return apiClient.post('/auth_bot', { login, password, locale });
  },

  sendMessageBot(message, thread_id, assistant_id, user_id) {
    return apiClient.post('/message_bot', {
      message,
      thread_id,
      assistant_id,
      user_id
    });
  },

  updateUserSettings(authToken, settings) {
    return apiClient.post('/update_user_settings', settings, {
      params: { auth_token: authToken },
    });
  },

  updateUserLocale(userId, locale) {
    return apiClient.get('/update_user_locale', {
      params: { user_id: userId, language: locale },
    });
  },

  deleteUserCreditCard(authToken) {
    return apiClient.get('/delete_user_credit_card', {
      params: { auth_token: authToken },
    });
  },

  getInternetPaymentDetails(authToken, tariffId, period) {
    return apiClient.get('/pay_for_internet_details', {
      params: { auth_token: authToken, tariff_id: tariffId, period },
    });
  },

  isPushTokenUser(userId, pushToken) {
    return apiClient.get('/is_push_token_user', {
      params: { user_id: userId, push_token: pushToken },
    });
  },

  checkUserSessionBot(login, thread_id, assistant_id) {
    return apiClient.get('/check_user_session', {
      params: { login, thread_id, assistant_id },
    });
  },

  getAdditionalServicesCheck(userId) {
    return apiClient.get(`/get_user_additional_services_check`, {
      params: { user_id: userId },
    })
  },
};
